import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
import {createParentPositions} from "../../constants";

export default class VanityLighting extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_lighting';
    this.partName = 'Vanity Lighting';
    this.translateId = "visualizer.bathroom.vanity.vanity_lighting";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    this.toggleLayerPositions();
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const vanityParent = this.getParent();
    // const activeSideMeta = vanityParent.getActiveMatchingMetaFromRelatedItem("vanity_cabinet", "Side");
    // if (activeSideMeta && activeSideMeta.includes("C")) {
    //   conditions.push({
    //     propName: "Side",
    //     propValue: activeSideMeta
    //   });
    // }
    if (vanityParent.mirror) {
      const condMirror = vanityParent.mirror.getArrayOfConditions();
      const condShape = condMirror.find(condition => condition.propName === "MirrorShape");
      if (condShape) {
        conditions.push(condShape);
      } else if (vanityParent.mirror?.activeFeature?.metaData["MirrorShape"]) {
        const mirrShape = vanityParent.mirror.activeFeature.metaData["MirrorShape"];
        const propValue = Array.isArray(mirrShape) && mirrShape.includes("24RD")
          ? "24D"
          : Array.isArray(mirrShape) && mirrShape.includes("24RS")
            ? "24S"
            : mirrShape
        conditions.push({
          propName: "MirrorShape",
          propValue: propValue,
        });
      }
    }
    return conditions
  }

}
